import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { PublicConfig } from "./config";

let client: SupabaseClient | null = null;

/**
 * One client for the tab's lifetime. PKCE, because the app runs in a browser
 * and the implicit flow leaves tokens in the URL.
 */
export function createBrowserClient(config: PublicConfig): SupabaseClient {
  if (client) return client;

  client = createClient(config.supabaseUrl, config.supabasePublishableKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
      storageKey: "cubby.auth",
    },
  });

  return client;
}
